export const themes = {
    light: {
        background: 'bg-white',
        text: 'text-gray-900',
        secondaryText: 'text-gray-600',
        headerBg: 'bg-gray-100',
        headerText: 'text-gray-800',
        dayBg: 'bg-slate-100',
        dayHeaderBg: 'bg-slate-300',
        inactiveDayBg: 'bg-slate-700',
        gridBg: 'bg-blue-100',
        divider: 'divide-gray-300',
        todayBg: 'bg-yellow-200',
        buttonHover: 'hover:text-gray-800',
        eventBg: 'bg-blue-100',
        eventHeaderBg: 'bg-blue-200',
        eventText: 'text-gray-900',
        modalBg: 'bg-white',
        modalOverlay: 'bg-black bg-opacity-50',
        link: 'text-blue-600 hover:text-blue-800',
        border: 'border-gray-200',
        tag: 'bg-blue-100 text-blue-800',
        loadingBg: 'bg-white',
        loadingText: 'text-gray-900',
        alertBackground: 'bg-red-200', 
        weekendHeaderBg: 'bg-slate-700',
        weekdayHeaderBg: 'bg-slate-600',
        dayNameText: 'text-slate-100',
        eventCountBg: 'bg-blue-300',
        button: 'bg-gray-400 !text-white',
        todayBackground: 'bg-gray-600 text-white',
        featuredDay: 'bg-yellow-300 italic',
        todayBarBackground: 'bg-gray-200',
    },
    dark: {
        background: 'bg-gray-900',
        text: 'text-gray-100',
        secondaryText: 'text-gray-300',
        headerBg: 'bg-gray-800',
        headerText: 'text-gray-100',
        dayBg: 'bg-gray-800',
        dayHeaderBg: 'bg-gray-700',
        inactiveDayBg: 'bg-gray-900',
        gridBg: 'bg-gray-700',
        divider: 'divide-gray-900',
        todayBg: 'bg-yellow-300/30',
        buttonHover: 'hover:text-white',
        eventBg: 'bg-slate-900',
        eventHeaderBg: 'bg-slate-800',
        eventText: 'text-gray-100',
        modalBg: 'bg-gray-800',
        modalOverlay: 'bg-black bg-opacity-70',
        link: 'text-slate-400 hover:text-slate-300',
        border: 'border-gray-700',
        tag: 'bg-slate-900 text-slate-200',
        loadingBg: 'bg-gray-800',
        loadingText: 'text-gray-100',
        alertBackground: 'bg-yellow-900',
        weekendHeaderBg: 'bg-slate-900',
        weekdayHeaderBg: 'bg-slate-600',
        dayNameText: 'text-slate-100',
        eventCountBg: 'bg-blue-900',
        button: 'bg-gray-400 !text-white',
        todayBackground: 'bg-grey-200 text-black',
        featuredDay: 'bg-yellow-600 italic text-black',
        todayBackground: 'bg-gray-300 text-black',
    }
}; 